import { downloadCsv } from "../../../../utils/csvExport.js";
import {
  APPROVAL_STATUS_BUCKETS,
  type ApprovalStatusBucket,
  type ApprovalStatusRunTotals,
} from "./approvalRequestStatus.js";
import { csvField, filenameStamp } from "./csvHelpers.js";
import type { InvalidApprovalRequestStatusRow } from "./parseApprovalRequestStatusCsv.js";

export const INVALID_ROWS_HEADERS = ["line", "approval_request_id", "status", "reason"] as const;

export const REPORT_HEADERS = ["approval_request_id", "outcome", "current_status"] as const;

export const DUPLICATE_REASON = "approval_request_id appears more than once";

export const MISMATCH_OUTCOME = "SKIPPED_NOT_NEW";

export const UNKNOWN_OUTCOME = "UNKNOWN";

export const BUCKET_OUTCOMES: Record<ApprovalStatusBucket, string> = {
  decided: "DECIDED",
  locked: "LOCKED",
  notFound: "NOT_FOUND",
  invalidStatus: "INVALID_STATUS",
  alreadyInTarget: "ALREADY_IN_TARGET_STATUS",
  callbackFailed: "CALLBACK_FAILED",
};

export function buildInvalidRowsCsv(
  invalid: InvalidApprovalRequestStatusRow[],
  duplicates: string[],
): string {
  const lines: string[] = [INVALID_ROWS_HEADERS.join(",")];
  for (const row of invalid) {
    lines.push([row.line, row.approvalRequestId, row.status, row.reason].map(csvField).join(","));
  }
  for (const approvalRequestId of duplicates) {
    lines.push([null, approvalRequestId, null, DUPLICATE_REASON].map(csvField).join(","));
  }
  return `${lines.join("\n")}\n`;
}

export function buildReportCsv(totals: ApprovalStatusRunTotals): string {
  const lines: string[] = [REPORT_HEADERS.join(",")];
  for (const bucket of APPROVAL_STATUS_BUCKETS) {
    for (const approvalRequestId of totals.buckets[bucket]) {
      lines.push([approvalRequestId, BUCKET_OUTCOMES[bucket], null].map(csvField).join(","));
    }
  }
  for (const mismatch of totals.mismatches) {
    lines.push([mismatch.id, MISMATCH_OUTCOME, mismatch.status].map(csvField).join(","));
  }
  for (const row of totals.unknown) {
    lines.push([row.approvalRequestId, UNKNOWN_OUTCOME, null].map(csvField).join(","));
  }
  return `${lines.join("\n")}\n`;
}

export function invalidRowsFilename(now: Date): string {
  return `approval-request-status-invalid-rows-${filenameStamp(now)}.csv`;
}

export function reportFilename(now: Date): string {
  return `approval-request-status-applied-${filenameStamp(now)}.csv`;
}

export function downloadInvalidRowsCsv(
  invalid: InvalidApprovalRequestStatusRow[],
  duplicates: string[],
  at: Date,
): void {
  downloadCsv(buildInvalidRowsCsv(invalid, duplicates), invalidRowsFilename(at));
}

export function downloadReportCsv(totals: ApprovalStatusRunTotals, at: Date): void {
  downloadCsv(buildReportCsv(totals), reportFilename(at));
}
